import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IKeHoachMonChiTietSaveRequest } from "../../model/request/ke-hoach/IKeHoachMonChiTietSaveRequest";
import { IKeHoachMonSelectByLopRequest } from "../../model/request/ke-hoach/KeHoachMonSelectByLopRequest";
import { apiClient } from "../apiClient";

export const KE_HOACH_MON_CHITIET_ENDPOINT = "ke-hoach-mon-chi-tiet";

export const keHoachMonChiTietApi = {
    Select: (request: IKeHoachMonSelectByLopRequest) => apiClient.post(`${KE_HOACH_MON_CHITIET_ENDPOINT}/select`, request),
    Saves: (request: IKeHoachMonChiTietSaveRequest) => apiClient.post(`${KE_HOACH_MON_CHITIET_ENDPOINT}`, request),
    Deletes: (request: IIdsRequest) => apiClient.put(`${KE_HOACH_MON_CHITIET_ENDPOINT}/deletes`, request),
   

}
